import { useCallback } from 'react';
import { useRouter, usePathname } from '@/i18n/routing';
import { useLocale } from 'next-intl';
import { useSearchParams } from 'next/navigation';
import { langs } from '@/i18n';

export function usePersistedLanguage() {
  const { push } = useRouter();
  const searchParams = useSearchParams();
  const pathname = usePathname();
  const locale = useLocale();

  const handleChangeLanguage = useCallback(
    (lang) => {
      try {
        push(`${pathname}?${searchParams}`, { locale: lang.value });
        if (window.axeptioSDK) {
          window.axeptioSDK.setCookiesVersion(`guestit-${langs[lang.value]}`);
        }
      } catch (e) {
        console.error(e);
      }
    },
    [locale, pathname, searchParams]
  );

  return [locale, handleChangeLanguage];
}
